export enum BasketsType {
    BOPIS = 'bopis',
    MIXED = 'mixed',
    SAME_DAY_DELIVERY = 'sameDayDelivery',
    SHIP_TO_ME = 'shipToMe',
}
